<template>
  <div>
    <!-- Semantic search in recipes database -->
    <RecipeList
      searchMode="semantic"
      :showSearchModeTogle="false"
      :useSavedFilter="useSavedFilter"
      :showFilters="false"
      @update:isLoading="isListLoading = $event"
      @update:isSemanticLoading="isListSemanticLoading = $event"
      :initial-recipes="initialRecipes"
      :restore-scroll="restoreScrollPosition"
      class="mt-4"
      @semantic-search-has-results="handleSemanticResults"
    ></RecipeList>

    <!-- Meal Type Selector -->
    <RecipeMeal
      v-if="
        showRecipeSuggested &&
        !isListLoading &&
        !isListSemanticLoading &&
        showMealSelector
      "
      class="mt-2"
      @meal-type-selected="handleMealTypeSelected"
    />

    <!-- Recipe suggestions -->
    <div
      v-if="
        showRecipeSuggested &&
        !isListLoading &&
        !isListSemanticLoading &&
        selectedMealType
      "
    >
      <RecipeSuggested
        :meal-type="selectedMealType"
        class="mt-4 mb-4"
        @suggestion-type="handleSuggestionType"
        key="suggested-with-meal-type"
      />
    </div>

    <hr
      v-if="showRecipeSuggested && !isListLoading && !isListSemanticLoading"
    />

    <!-- Onboarding message for new users -->
    <div
      v-if="showOnboardingMessage"
      class="alert alert-warning alert-dismissible fade show small text-center mt-3 mb-4"
      role="alert"
    >
      <i class="bi bi-info-circle me-2"></i>
      Чем больше вы пользуетесь Cooksy (ставите лайки, добавляете в избранное),
      тем лучше я понимаю ваши вкусы!
      <button
        type="button"
        class="btn-close"
        @click="hideOnboardingMessage"
        aria-label="Close"
      ></button>
    </div>

    <!-- Popular Recipes Section -->
    <PopularRecipes
      v-if="showRecipeSuggested && !isListLoading && !isListSemanticLoading"
      class="mt-4"
      @show-full-recipe="showFullRecipeFromPopular"
    />

    <!-- Recipe of the Day -->
    <ArticleOfTheDay
      :articletype="'recipe_of_the_day'"
      v-if="showRecipeSuggested && !isListLoading && !isListSemanticLoading"
    />

    <!-- Article of the Day -->
    <ArticleOfTheDay
      v-if="showRecipeSuggested && !isListLoading && !isListSemanticLoading"
    />

    <!-- <hr /> -->
    <!-- Yandex.RTB R-A-16547705-1 -->
    <!-- <div id="yandex_rtb_R-A-16547705-1"></div> -->

    <!-- ads-001 -->
    <!-- <ins
      class="adsbygoogle"
      style="display: block"
      data-ad-client="ca-pub-1799261900056822"
      data-ad-slot="7463632362"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins> -->

    <!-- Chat for choosing a dish -->
    <ChatRecipeTitle />

    <!-- About Project Section -->
    <CooksyAbout
      v-if="showRecipeSuggested && !isListLoading && !isListSemanticLoading"
    />
  </div>
</template>

<script>
import RecipeSuggested from "../RecipeSuggested.vue";
import RecipeMeal from "../RecipeMeal.vue";
import RecipeList from "../RecipeList.vue";
import PopularRecipes from "../PopularRecipes.vue";
// import RecipeOfTheDay from "../RecipeOfTheDay.vue";
import ArticleOfTheDay from "../ArticleOfTheDay.vue";
import ChatRecipeTitle from "../ChatRecipeTitle.vue";
import CooksyAbout from "../CooksyAbout.vue";

export default {
  name: "PageHome",
  components: {
    RecipeSuggested,
    RecipeList,
    RecipeMeal,
    PopularRecipes,
    // RecipeOfTheDay,
    ArticleOfTheDay,
    ChatRecipeTitle,
    CooksyAbout,
  },

  data() {
    return {
      showRecipeSuggested: false,
      selectedMealType: null,
      useSavedFilter: false,
      showOnboardingMessage: false,
      initialRecipes: null,
      restoreScrollPosition: 0,
      isListLoading: false,
      isListSemanticLoading: false,
      showMealSelector: false, // Controls visibility of RecipeMeal. Default to false.
    };
  },

  created() {
    // Check lastviewed state in localStorage for RecipeList
    // This logic must be in `created` because the child component `RecipeList`
    // depends on the `useSavedFilter` prop, and the child's `mounted` hook
    // runs before the parent's `mounted` hook.
    const lastViewedRecipe = localStorage.getItem("lastViewedRecipe");
    if (lastViewedRecipe) {
      const obj = JSON.parse(lastViewedRecipe);
      // Check if we are returning from a recipe view that was accessed from the main list
      if (obj && obj.from === "all") {
        this.useSavedFilter = true;
        // If there's a saved state, prepare it for the child component
        if (this.$globalState.lastSearchState.results) {
          this.initialRecipes = this.$globalState.lastSearchState.results;
          this.restoreScrollPosition =
            this.$globalState.lastSearchState.scrollPosition;
        }
        // We've used the flag, now we can remove it to prevent issues on reload
        localStorage.removeItem("lastViewedRecipe");
      } else {
        // This is not a return from a recipe list, so don't use saved filter.
        // This also handles cases like returning from 'popular' or 'suggested'.
        this.useSavedFilter = false;
      }
    } else {
      // No lastViewedRecipe item, so it's a fresh visit.
      this.useSavedFilter = false;
    }

    // If we are not restoring state, it's a fresh visit to home, so clear any old search state
    if (!this.useSavedFilter && this.$globalState.lastSearchState.results) {
      this.$globalState.lastSearchState = {
        searchTerm: null,
        results: null,
        scrollPosition: 0,
      };
    }
  },

  mounted() {
    // Check if the onboarding message should be shown
    const hasInteracted = localStorage.getItem("cooksy_user_has_interacted");
    if (!hasInteracted) {
      this.showOnboardingMessage = true;
    }

    // Set initial meal type on mount
    if (!this.selectedMealType) {
      this.selectedMealType = this.getMealTypeByTime();
    }

    // Yandex Ads
    // We need to check if the Yandex context is available on the window object.
    // It's usually loaded from an external script in index.html.
    // const isLocalhost =
    //   window.location.hostname === "localhost" ||
    //   window.location.hostname === "127.0.0.1";

    // if (window.yaContextCb) {
    //   window.yaContextCb.push(() => {
    //     window.Ya.Context.AdvManager.render({
    //       blockId: "R-A-16547705-1",
    //       renderTo: "yandex_rtb_R-A-16547705-1",
    //       demo: isLocalhost, // Use demo mode on localhost
    //     });
    //   });
    // }

    // Declare adsbygoogle before using it
    // window.adsbygoogle = window.adsbygoogle || [];
    // window.adsbygoogle.push({});
  },

  unmounted() {
    this.teoweb.delReader(this.reader);
  },

  methods: {
    handleSemanticResults(hasResults) {
      // If semantic search has results, hide RecipeSuggested, RecipeMeal, and PopularRecipes.
      // Otherwise, show them.
      this.showRecipeSuggested = !hasResults;
      console.log(
        "PageHome: handleSemanticResults, hasResults:",
        hasResults,
        "showRecipeSuggested (and related):",
        this.showRecipeSuggested
      );
      if (hasResults) {
        this.selectedMealType = null; // Clear meal type if semantic search has results
      }
      // If !hasResults, RecipeMeal will be shown and will emit its default or saved mealType
    },

    handleMealTypeSelected(mealType) {
      this.selectedMealType = mealType;
      console.log("PageHome: Meal type selected:", this.selectedMealType);
    },

    handleSuggestionType(payload) {
      // Hide meal selector if the suggestion is random
      this.showMealSelector = !payload.isRandom;
    },

    showFullRecipeFromPopular(recipe) {
      console.log(
        "PageHome: showFullRecipeFromPopular triggered for",
        recipe.name
      );
      localStorage.setItem(
        "lastViewedRecipe",
        JSON.stringify({ from: "popular", id: recipe.id })
      );
      window.location.hash = `/recipes/${recipe.id}`;
    },

    hideOnboardingMessage() {
      if (this.showOnboardingMessage) {
        this.showOnboardingMessage = false;
        localStorage.setItem("cooksy_user_has_interacted", "true");
      }
    },

    getMealTypeByTime() {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) {
        return "завтрак";
      } else if (hour >= 12 && hour < 17) {
        return "обед";
      } else {
        return "ужин";
      }
    },
  },
};
</script>
